"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    span.nobreak {
        white-space: nowrap;
    }
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    @media screen and ${constants_1.Device.mobileL} {
        font-size: 14px;
    }
    .ecrp-confirm-wrapper {
        h1 {
            span.yellow {
                color: yellow;
            }
        }
        max-width: 60vw;
        &.with-bonus {
            max-width: 85vw;
            .ecrp-confirm-table {
                width: 60%;
            }
        }
        @media screen and ${constants_1.Device.tablet} {
            max-width: 100%;
        }
        position: relative;
        display: flex;
        flex-direction: column;
        @media only screen and (max-height: 600px) {
            height: 100%;
        }
        @media screen and ${constants_1.Device.mobileL} {
            padding-top: 5%;
        }
        .ecrp-confirm-close {
            position: absolute;
            right: 0;
            top: 0;
            font-size: 2em;
            cursor: pointer;
            &:hover {
                transform: scale(1.2);
            }
            @media screen and ${constants_1.Device.mobileL} {
                top: 3%;
                right: 3%;
            }
        }
        .ecrp-confirm-content {
            padding: 3% 5%;
            text-align: center;
            .ecrp-confirm-detail {
                .ecrp-confirm-detail-row {
                    display: flex;
                    text-align: initial;
                    flex-wrap: nowrap;
                    padding: 3% 0;
                    border-bottom: 1px solid gray;
                    font-size: 1.2em;
                    &:first-child {
                        border-top: 1px solid gray;
                    }
                    .ecrp-confirm-detail-row-name {
                        flex: 1;
                        text-align: left;
                    }
                    .ecrp-confirm-detail-row-value {
                        text-align: right;
                    }
                }
            }
            .ecrp-confirm-action {
                display: flex;
                justify-content: center;
                button {
                    color: black;
                }
                .ecrp-confirm-reset {
                    background: transparent;
                    margin-left: 2em;
                    color: white;
                }
            }
            .confirm-error-msg {
                margin-top: 15px;
                &.opaque {
                    opacity: 1;
                }
            }
        }
        .slick-list {
            width: 80%;
        }
    }
`;
//# sourceMappingURL=ConfirmOverlayStyled.js.map